<template>
	
	<div class="enableWhatsapp">
		<p>Add your mobile number to access Money Guided’s AI financial coach</p>
		<v-divider></v-divider>
		<div class="toggle-row">
			<span>Enable AI coach via WhatsApp</span>
			<MGToggle v-model="enableWhatsapp" @update:modelValue="$event ? $emit('on') : $emit('off')" />
		</div>
	</div>
	
</template>

<script>
import MGToggle from './MGToggle.vue';

export default {
	name: "EnableWhatsappWidget",
	components: { MGToggle },
	props: ['formatter'],
	data() {
		return{
			enableWhatsapp: false
		}
	},
	computed: {
	},
	methods: {
		onLoad() {
		}
	},
	mounted: function() { this.onLoad(); }
}
</script>

<style scoped>
.toggle-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 8px 0;
}

.enableWhatsapp {
	border-radius: 20px;
	padding: 20px;
	padding-bottom: 40px;
	background: linear-gradient(243.52deg, #FCE5D4 18.85%, #E0C5C8 81.37%);
	margin-top: 20px;
	margin-bottom: 20px;
	color: var(--text-color);
}


</style>